import { createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'api/client';
import { axiosBaseQuery } from 'helper/axios/axiosBaseQuery';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL,
  }),
  tagTypes: [
    'user',
    'asset',
    'client',
    'expense',
    'expenseHead',
    'expenseSubHead',
    'fixedAsset',
    'investment',
    'product',
    'vendor',
    'voucher',
    'invoice',
    'vehicle',
    'driver',
    'vehicleExpenseCategory',
    'vehicleExpenseHead',
    'serviceProvider',
    'fuelPrice',
    'paymentSource',
    'serviceItem',
    'vehicleExpense',
  ],
  endpoints: () => ({}),
});
